import { render, staticRenderFns } from "./CourseBenefits.vue?vue&type=template&id=0bdc1085&scoped=true&"
import script from "./CourseBenefits.vue?vue&type=script&lang=js&"
export * from "./CourseBenefits.vue?vue&type=script&lang=js&"
import style0 from "./CourseBenefits.vue?vue&type=style&index=0&id=0bdc1085&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdc1085",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
